import DashboardAdvantage from "./Page/DashboardAdvantage";
import DeductionMedical from "./Page/DeductionMedical";
import DeductionReport from "./Page/DeductionReport";
import PayStubReport from "./Page/PayStubReport";
import * as React from 'react';
import { Route, Switch } from 'react-router';
import Settings from "./Page/Settings";
import ContactIt from "./Page/ContactIt";
import PaystubConfiguration from "./Page/PaystubConfiguration";
import Forms from "./Page/Forms";

export const Routes = () => <Switch>
    <Route exact path='/' component={DashboardAdvantage} />
    <Route exact path='/dashboard-advantage' component={DashboardAdvantage} />
    <Route exact path='/report-deduction' component={DeductionReport} />
    <Route exact path='/medical-deduction' component={DeductionMedical} />
    <Route exact path='/pay-stub' component={PayStubReport} />
    <Route exact path='/contact-it' component={ContactIt} />
    <Route exact path='/settings' component={Settings} />
    <Route exact path='/paystub-configuration' component={PaystubConfiguration} />
    <Route exact path='/forms' component={Forms} />
</Switch>
